import { Fragment } from 'react';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { StyledDivider } from '@webclient/components/search-forms/gamification-search/actions/bots-selector/styles';

type Props = {
  count: number;
};

const SKELETON_WIDTH = '100%';
const SKELETON_HEIGHT = 135;

export default function SkeletonLoading({ count }: Props) {
  return (
    <Stack>
      {Array.from({ length: count }).map((_, index) => (
        <Fragment key={index}>
          <Skeleton
            variant="rectangular"
            width={SKELETON_WIDTH}
            height={SKELETON_HEIGHT}
          />
          <StyledDivider />
        </Fragment>
      ))}
    </Stack>
  );
}
